export const LOGIN_ERROR = 'loginError';

export function setLoginError(loginError: string): void {
    localStorage.setItem(LOGIN_ERROR, loginError);
}

export function getLoginError(): string {
    return localStorage.getItem(LOGIN_ERROR) || '';
}

export function clearLoginError(): void {
    localStorage.removeItem(LOGIN_ERROR);
}
